import './index.css'
import * as React from 'react'
import type { EmailCampaignTrack } from 'types/campaign'
import TrackListArtwork from './track-list-artwork'
type Props = {
  tracks: EmailCampaignTrack[]
  type: 'streams' | 'downloads'
}

/**
 * Tracks list component for displaying email campaign track statistics
 * Shows track name, artist, artwork, and action counts (streams or downloads)
 * @param tracks - Array of email campaign track objects with statistics
 * @param type - Type of action to display: 'streams' or 'downloads'
 */
const TracksList = ({ type, tracks }: Props): React.ReactElement<'div'> => (
  <div className="tracks-list">
    {tracks.map((track, index) => (
      <div key={index} className="tracks-list__row">
        <TrackListArtwork track={track} type={type} />
        <div className="tracks-list__row__details">
          <div className="tracks-list__row__details__name">{track.name}</div>
          <div className="tracks-list__row__details__artist">
            {track.artist}
          </div>
        </div>
        <div className="tracks-list__row__action-count">{track.count}</div>
      </div>
    ))}
  </div>
)

export default TracksList
